import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { ssoLoginRequirementParser, workspaceLoginMfaRequirement, } from '#validation';
export const WorkspaceLoginStatusSchema = z.object({
    ssoLoginRequirement: ssoLoginRequirementParser,
    mfaRequirement: workspaceLoginMfaRequirement,
});
export class WorkspaceLoginStatusResponseDto extends createZodDto(WorkspaceLoginStatusSchema) {
}
